var React = require('react');

function IconCancellation (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("g",{"key":0},React.createElement("path",{"fill":"#0D2A6E","d":"M20.4,2.9c-8.8,0-17.5,8.6-17.5,17.6c0,9.6,7.8,17.5,17.5,17.5s17.5-7.8,17.5-17.5S30.2,2.9,20.4,2.9z M20.4,36C12,36,4.9,29,4.9,20.5c0-7.8,7.8-15.7,15.5-15.7c8.6,0,15.5,7.1,15.5,15.5C36.1,29,29,36,20.4,36z"})),React.createElement("path",{"fill":"#0D2A6E","d":"M26.5,14.5c-0.4-0.4-1-0.4-1.4,0l-4.7,4.7l-4.5-4.7c-0.4-0.4-1.2-0.4-1.6,0s-0.4,1,0,1.4l4.7,4.7l-4.7,4.7 c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.4,0.2,0.8,0.2s0.6,0,0.8-0.2l4.7-4.7l4.7,4.7c0.2,0.2,0.4,0.2,0.8,0.2c0.4,0,0.6,0,0.8-0.2 c0.4-0.4,0.4-1,0-1.4l-5.1-4.7l4.7-4.7C26.9,15.4,26.9,14.9,26.5,14.5z","key":1})]));
}

IconCancellation.defaultProps = {"x":"0","y":"0","enableBackground":"new 0 0 40 40","version":"1.1","viewBox":"0 0 40 40","xmlSpace":"preserve"};

module.exports = IconCancellation;

IconCancellation.default = IconCancellation;
